import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconBroomProps extends SVGProps<any> {}
export class SVGIconBroom extends Component<
  SVGIconBroomProps & { translateY?: number }
> {
  render() {
    const {
      width = 25,
      height = 31.5,
      scale = 1,
      fill = '#513389',
      translateY = 7,
      ...rest
    } = this.props;
    return (
      <SVG
        className="svg-icon-broom"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        transform={`matrix(${+scale * 2.5} 0 0 ${
          +scale * 2.5
        } 0 ${translateY} )`}
        {...rest}
      >
        <path
          d="M19.07,13,19,12.44V11.5A2.5,2.5,0,0,0,16.5,9H14V5.5a1.5,1.5,0,0,0-3,0V9H8.5A2.5,2.5,0,0,0,6,11.5v.94L5.93,13,5,20.44a.551.551,0,0,0,.12.39A.517.517,0,0,0,5.5,21h14a.517.517,0,0,0,.38-.17.551.551,0,0,0,.12-.39ZM7,11.5A1.5,1.5,0,0,1,8.5,10h3a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,1,1,0v4a.5.5,0,0,0,.5.5h3A1.5,1.5,0,0,1,18,11.5V12H7ZM18.27,20l-.28-1.59a.494.494,0,0,0-.58-.4.489.489,0,0,0-.4.58L17.25,20H15.68l-.69-4.57a.495.495,0,1,0-.98.14L14.67,20H8.77L9,17.55a.5.5,0,1,0-1-.1L7.76,20H6.07l.88-7H18.06l.87,7Z"
          fill={fill}
          stroke="#513389"
          strokeWidth="0.6"
        />
      </SVG>
    );
  }
}
